"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    d.useSystemTimer += ds;
    var useSystemTime = 0.5;
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        if (tHere) {
            var sys = tHere.system;
            if (sys) {
                var toHeal = obj;
                if (toHeal && !toHeal.isDying) {
                    var healRate = 20;
                    var healAmount = healRate * useSystemTime;
                    if (toHeal.energy < diveCrew_sidecar_1.diveCrew.maxEnergy) {
                        var p = voyageParticles_sidecar_1.voyageParticles.create('zzz', obj.x, obj.y);
                        p.image.tint = voyageColors_sidecar_1.voyageColors.green;
                        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                            diveCrew_sidecar_1.diveCrew.hurtEnergy(toHeal, -healAmount);
                        }
                    }
                }
            }
        }
    }
}
exports.crewUpdate = crewUpdate;
